<template>
  <el-drawer
    v-if="visible"
    visible
    :title="$l('dialog_title_amzReportRecordDetail')"
    direction="rtl"
    :size="1100"
    @close="() => close()"
  >
    <div class="drawer-main">
      <Main
        ref="main"
        :reportTaskRecordCode="reportTaskRecordCode"
        @reload="$emit('reload')"
        @close="close()"
      />
    </div>
    <div class="drawer-footer">
      <el-button size="small" @click="close()">
        {{ this.$l('INDEX.btn_close') || '关闭' }}
      </el-button>
    </div>
  </el-drawer>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    reportTaskRecordCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 20px 10px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
